<div class="container row d-flex justify-content-center dynamic-html">
    <div class="col-8 mt-5">
        <div class="text" [innerHTML]="'globalrichtext.'+ type | translate | safeHtml">
        </div>
    </div>
</div>